import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgComputerDollar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.269 3.06v2.893a2.56 2.56 0 0 0 2.554 2.561h2.739m-4.298-4.883A2.05 2.05 0 0 0 13.786 3H8.135a3.747 3.747 0 0 0-3.761 3.657v10.508a3.753 3.753 0 0 0 3.67 3.834L15.97 21a3.81 3.81 0 0 0 3.657-3.835V8.999c0-.529-.205-1.038-.57-1.42z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.712 10.828h-2.397a1.291 1.291 0 1 0 0 2.582h1.475a1.29 1.29 0 1 1 0 2.583H9.392M11.053 15.992v1.084m0-7.339v1.094"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComputerDollar);
export default ForwardRef;
